
import { Pipe, PipeTransform } from '@angular/core';
import {TextOperatorType} from "../../models/text-operator";

@Pipe({
  name: 'filterOperators',
  pure: false // ensures that the pipe is reevaluated when the `multiple` value changes
})
export class FilterOperatorsPipe implements PipeTransform {

  transform(operators: string[], multiple: boolean): string[] {
    if (!operators || operators.length === 0) {
      return [];
    }

    // Filter based on the value of 'multiple'
    return multiple
      ? operators.filter((o) => {
        return o !== TextOperatorType.EQUAL.toString() && o !== TextOperatorType.NOT_EQUAL.toString();
      })
      : operators.filter((o) => {
        return o !== TextOperatorType.INCLUDES.toString() && o !== TextOperatorType.NOT_INCLUDES.toString();
      });
  }
}
